"use client";
/**
 * Client-side canonical link component
 * Dynamically adds canonical links to the document head
 */
import { useEffect } from 'react';
import { useCanonicalUrl } from '@/hooks/useCanonicalUrl';

interface DynamicCanonicalLinkProps {
  customPath?: string;
  lang?: string;
}

export default function DynamicCanonicalLink({ 
  customPath, 
  lang 
}: DynamicCanonicalLinkProps) {
  const canonicalUrl = useCanonicalUrl(customPath, lang);

  useEffect(() => {
    if (!canonicalUrl) return;

    // Remove ALL existing canonical links to avoid duplicates
    const existingCanonicals = document.querySelectorAll('link[rel="canonical"]');
    existingCanonicals.forEach((el) => el.parentElement?.removeChild(el));

    // Add new canonical link
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);

    // Cleanup: ensure we remove this exact link if effect re-runs/unmounts
    return () => {
      if (link.parentElement) {
        link.parentElement.removeChild(link);
      }
    };
  }, [canonicalUrl]);

  return null; // This component doesn't render anything visible
}
